import { NodeMapValue } from '@common/prosemirror/model/node-find';
import { iterateChildren } from '@common/prosemirror/model/node-iterate';
import { Node } from 'prosemirror-model';

export const NodeIdAttrName = 'nodeId';
export const NodeIdRootValue = 'root';
export const NodeIdMissingValue = 'missing';

/** Returns node's ID if specified, otherwise returns an undefined value. */
export function getNodeId(node: Node): string {
  const id = node.attrs[NodeIdAttrName];
  return id === NodeIdMissingValue ? undefined : id;
}

/** Returns a child node data if the child node with the specified ID is found. */
export function findChildNode(node: NodeMapValue, childId: string): NodeMapValue {
  let child;
  iterateChildren(node, null, (item) => {
    const nodeId = getNodeId(item.node);
    if (nodeId === childId) {
      child = item;
      return false;
    }
  });
  return child;
}
